import { AvForm } from 'availity-reactstrap-validation';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';

import BottyImage from 'src/modules/3rd-party-management/assets/images/bottyAi-2.png';
import DynamicFormField from './DynamicFormField';
import { getSeedInputFieldDefinitions } from '../constants/fieldDefinitions';

const AiSeedSection = ({
    t,
    lng,
    values,
    countriesList,
    isAiLoading,
    canGenerate,
    onFieldChange,
    onGenerateWithAi,
}) => {
    const seedFields = getSeedInputFieldDefinitions(values.type, values);

    return (
        <Card className="ai-seed-section">
            <CardBody>
                <Row className="align-items-center">
                    <Col lg="3" md="4" className="text-center mb-4 mb-md-0">
                        <img
                            src={BottyImage}
                            alt="Botty AI"
                            className="ai-seed-section__botty-image"
                        />
                    </Col>
                    <Col lg="9" md="8">
                        <h5 className="mb-2">{t('Let AI prepare your form')}</h5>
                        <p className="text-muted mb-4">
                            {t('Enter a few basic details below and Botty will look up publicly available information to pre-fill the rest of the third party profile. You can review and edit every field before creating the record.')}
                        </p>

                        <div className="row">
                            {seedFields.map((field) => (
                                <DynamicFormField
                                    key={field.key}
                                    field={field}
                                    values={values}
                                    t={t}
                                    lng={lng}
                                    countriesList={countriesList}
                                    onChange={onFieldChange}
                                />
                            ))}
                        </div>

                        <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                            <Button
                                color="primary"
                                type="button"
                                disabled={!canGenerate || isAiLoading}
                                onClick={onGenerateWithAi}
                            >
                                {isAiLoading && (
                                    <Spinner size="sm" className="me-2" animation="border" />
                                )}
                                {t('Prepare Form with AI')}
                            </Button>
                            {isAiLoading && (
                                <span className="text-muted small">
                                    {t('Fetching company information with AI')}...
                                </span>
                            )}
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default AiSeedSection;
